import logo from "../assets/vectr42Logo.png";
import logoSmall from "../assets/logo-small.png";

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <img src={logo} alt="Vector42 Logo" className="logo-img" />
          <span className="logo-text">vectr42</span>
        </div>
        <nav className="header-nav header-nav-center">
          <ul>
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="https://www.storyworks42.com/about" target="_blank" rel="noreferrer">About</a>
            </li>
          </ul>
        </nav>
        <div className="header-right">
          <span className="header-product-from">a product from</span>
          <div className="header-brand">
            <img src={logoSmall} alt="Storyworks" className="header-logo-small" />
            <span className="header-brand-name">storyworks42</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
